module.exports = __webpack_public_path__ + "static/img/06.ba29b41.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sub/worship/06.png
// module id = pj9t
// module chunks = 1